<template>
  <div class="user-profile">
    <!--  Header user info -->
    <div class="header header-user-profile mean-header">
      <h1>ملف المستخدم</h1>
    </div>
    <!-- Loading -->
    <LoadingComponent v-if="is_loading" />
    <!-- Error -->
    <ErrorComponent v-else-if="error && !is_loading" :error="error" />
    <!--  User info -->
    <template v-else>
      <div class="container container-component px-lg-5">
        <UserInfoComponent :data="user_data" :refresh="get_profile_data" />
      </div>
      <!-- Courses Rank Score -->
      <!-- <div class="header header-student-rank-score sub-header">
        <h2>مركزك في المنصة</h2>
      </div>
      <div class="container container-component px-lg-5">
        <RankScoreComponent :data="user_data" :refresh="get_profile_data" />
      </div> -->
      <!-- Courses statistics -->
      <div class="header header-courses-statistics sub-header">
        <h3>احصائيات كورساتك</h3>
      </div>
      <div class="container container-component px-lg-5">
        <CoursesStatisticsComponent />
      </div>
      <!-- Platform statistics -->
      <!-- <div class="header header-platform-statistics sub-header">
        <h4>احصائياتك على المنصة</h4>
      </div>
      <div class="container container-component px-lg-5">
        <PlatformStatisticsComponent />
      </div> -->
    </template>
  </div>
</template>

<script>
import axios from "axios";
import {
  UserInfoComponent,
  CoursesStatisticsComponent,
  // PlatformStatisticsComponent,
} from "../../components";
import LoadingComponent from "@/components/Loading/LoadingComponent.vue";
import config from "@/services/config";
import ErrorComponent from "@/components/Error/ErrorComponent.vue";
import Cookies from "js-cookie";
// import RankScoreComponent from "@/components/Profile/RankScore/RankScoreComponent.vue";
export default {
  name: "UserProfileView",
  components: {
    UserInfoComponent,
    CoursesStatisticsComponent,
    // PlatformStatisticsComponent,
    LoadingComponent,
    ErrorComponent,
    // RankScoreComponent,
  },
  data() {
    return {
      user_data: {},
      is_loading: true,
      error: null,
    };
  },
  created() {
    if (Cookies.get("user_data")) {
      this.user_data = JSON.parse(Cookies.get("user_data"));
      this.is_loading = false;
    } else {
      Cookies.remove("user_data");
      this.get_profile_data();
    }
  },
  methods: {
    get_profile_data() {
      this.user_data = {};
      axios
        .get(`${config.basURL}student/student-profile`, {
          headers: {
            auth: this.$store.state.userToken,
          },
        })
        .then((res) => {
          this.user_data = res?.data;
          this.$store.commit("SET_STUDENT_NAME", res?.data.name);
          Cookies.set("user_data", JSON.stringify(res?.data));
        })
        .catch((err) => {
          this.error = err?.response?.status
            ? err.response.status
            : err.message;
          console.log(err.message);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.user-profile {
  min-height: calc(100vh - 135px);
  background-color: #f9f9f9;
  padding: 4rem 0;
}

.user-profile .header {
  text-align: center;
  position: relative;
  margin: 2rem 0 6rem 0;
}

.user-profile .header::before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: #00000050;
  position: absolute;
  z-index: 0;
  top: 50%;
  left: 0;
  transform: translate(0, -100%);
}

.user-profile .header.sub-header::before {
  width: 90%;
  left: 5%;
}

.user-profile .header.sub-header {
  margin: 10rem 0 7rem 0;
}

.user-profile .header h1,
.user-profile .header h2,
.user-profile .header h3,
.user-profile .header h4 {
  margin: 0 auto;
  text-align: center;
  border: 1px solid #00000050;
  color: #000;
  background-color: #f9f9f9;
  font-size: 1.25rem;
  font-weight: 500;
  width: fit-content;
  padding: 1rem 5.5rem;
  border-radius: 37px;
  position: relative;
  z-index: 1;
}

.user-profile .header.sub-header h2,
.user-profile .header.sub-header h3,
.user-profile .header.sub-header h4 {
  background-color: #f9f9f9;
  border-radius: none;
  border: none;
}

/* Dark mode */
body.dark .user-profile {
  background-color: #13323a;
}

body.dark .user-profile .header::before {
  background-color: #ffffff;
}

body.dark .user-profile .header h1,
body.dark .user-profile .header h2,
body.dark .user-profile .header h3,
body.dark .user-profile .header h4 {
  color: #fff;
  background-color: #1d4955;
  border: 1px solid #ffffff50;
}

body.dark .user-profile .header.sub-header h1,
body.dark .user-profile .header.sub-header h2,
body.dark .user-profile .header.sub-header h3,
body.dark .user-profile .header.sub-header h4 {
  background-color: #13323a;
  border: none;
  border-radius: none;
}

/*  Media queries */
@media screen and (max-width: 992px) {
  .container-component {
    max-width: 100%;
    padding: 0;
  }

  .user-profile .header.sub-header::before {
    width: 100%;
    left: 0;
  }

  .user-profile .header h1 {
    padding: 1rem 3rem;
    font-size: 1rem;
  }
}

@media screen and (max-width: 768px) {
  .user-profile .header h1,
  .user-profile .header h2,
  .user-profile .header h3 .user-profile .header h4 {
    padding: 1rem 1.5rem;
    font-size: 0.875rem;
  }
}
</style>
